const compactUkPostcode = /^([A-Z]{1,2}\d[A-Z\d]?)(\d[A-Z]{2})$/;

const outwardPostcode = (
  postcode: string | null | undefined,
): string | null => {
  const trimmed = postcode?.trim().toUpperCase();
  if (!trimmed) {
    return null;
  }

  const [outward, inward] = trimmed.split(/\s+/);
  if (outward && inward) {
    return outward;
  }

  return compactUkPostcode.exec(trimmed.replaceAll(' ', ''))?.[1] ?? null;
};

const directoryProfileHeading = (
  name: string,
  postcode: string | null | undefined,
) => {
  const place = outwardPostcode(postcode);
  if (!place) {
    return name;
  }

  return `${name}, ${place}`;
};

export const directoryProfileTitle = (
  name: string,
  postcode: string | null | undefined,
) => `${directoryProfileHeading(name, postcode)} — Budgy`;
